import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/leadFunctions/contractTemplateActions'
import * as api from '../../api/lead/templates'

function* getContractTemplates(action) {
  try {
    const payload = yield call(api.getContractTemplates, action.jobId)
    yield put({ type: constants.GET_CONTRACT_TEMPLATES.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_CONTRACT_TEMPLATES.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetContractTemplates() {
  yield takeLatest(constants.GET_CONTRACT_TEMPLATES.ACTION, getContractTemplates)
}

export function* rootSaga() {
  // add more sagas here
  yield all([fork(watchGetContractTemplates)])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/leadFunctions/contractTemplateSaga.js